import { render, staticRenderFns } from "./ComplaintItem.vue?vue&type=template&id=86cd3b9a&"
import script from "./ComplaintItem.vue?vue&type=script&lang=js&"
export * from "./ComplaintItem.vue?vue&type=script&lang=js&"
import style0 from "./ComplaintItem.vue?vue&type=style&index=0&id=86cd3b9a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports